import {Injectable} from "@angular/core";
import {IDataModel} from './../../services/IDataModel';
import {Http, URLSearchParams, RequestOptions} from '@angular/http';
import * as _ from "lodash";
import {
    LeadsFilter, LeadsModel, AssignOpenerToLeads, LeadUpdateModel, LeadStatusModel, LeadScheduleModel
} from "./leads.model";

@Injectable()
export class LeadImportsService implements IDataModel {

    constructor(private http: Http) {}

    getList(filter: LeadsFilter) {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in filter) {

            if (key == 'fields') {
                for (let key in filter.fields) {
                    let fieldName = Object.keys(filter.fields[key])[0];
                    params.set(fieldName, filter.fields[key][fieldName]);
                }
            } else {
                params.set(key, filter[key] === null ? 'null' : filter[key]);
            }
        }
        return this.http.get('/lead-imports', new RequestOptions({
                search: params
            }));
    }

    remove(id: number) {
        return this.http.delete(`/lead-imports/${id}`)
    }
}


// WEBPACK FOOTER //
// ./src/app/models/leads/leadImports.service.ts